import React, { useState, useEffect } from 'react';
import { BiMessageRoundedDots } from 'react-icons/bi';
import { IoClose } from 'react-icons/io5';

const ChatWidget = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    let scrollTimeout;
    let scrollTriggered = false;

    const handleScroll = () => {
      const scrollPercent = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;
      
      if (scrollPercent >= 50 && !scrollTriggered) {
        scrollTriggered = true;
        scrollTimeout = setTimeout(() => {
          setIsVisible(true);
        }, 12000); // 12 secondes après 50% de scroll
      }
    };

    window.addEventListener('scroll', handleScroll);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (scrollTimeout) clearTimeout(scrollTimeout);
    };
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (message.trim()) {
      console.log('Message envoyé:', message);
      setMessage('');
      setIsOpen(false);
    }
  };

  if (!isVisible) return null;

  return (
    <>
      {/* Chat Button */}
      <div className="chat-widget-button" onClick={() => setIsOpen(true)}>
        <div className="chat-widget-icon">
          <BiMessageRoundedDots size={24} />
        </div>
      </div>

      {/* Chat Window */}
      {isOpen && (
        <div className="chat-widget-window">
          <div className="chat-widget-header">
            <h3 className="text-sm sm:text-base">
              <BiMessageRoundedDots style={{display: 'inline', marginRight: '8px'}} /> 
              <span className="hidden sm:inline">Support Bravo Energy</span>
              <span className="sm:hidden">Support</span>
            </h3>
            <button 
              className="chat-widget-close"
              onClick={() => setIsOpen(false)}
            >
              <IoClose size={20} />
            </button>
          </div>
          <div className="chat-widget-content">
            <div className="chat-widget-message">
              <p className="text-sm sm:text-base">Bonjour ! Comment puis-je vous aider aujourd'hui ?</p>
            </div>
            <form onSubmit={handleSubmit} className="chat-widget-form">
              <input
                type="text"
                placeholder="Tapez votre message..."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                className="chat-widget-input text-sm sm:text-base"
              />
              <button type="submit" className="chat-widget-send">
                Envoyer
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default ChatWidget; 